import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39b22598&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b22598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b22598')) {
      api.createRecord('39b22598', component.options)
    } else {
      api.reload('39b22598', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39b22598&scoped=true&", function () {
      api.rerender('39b22598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/customers/transCust/index.vue"
export default component.exports